import React from "react";
import { branch } from "baobab-react/higher-order";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Flexbox from "flexbox-react";

import MultiSelectToolbar from "./app-multiselect-toolbar";

import { selectAllMembers, resetSelectedMembers } from "../../actions/orgsActions";

class MultiSelectMembersToolbar extends React.PureComponent {
	render() {
		let multiSelectToolbar =
			<MultiSelectToolbar
				selectedItems={this.props.selectedMembers}
				onClickClose={() => {
					this.props.dispatch(
						resetSelectedMembers
					);
				}}
				onClickSelectAll={() => {
					this.props.dispatch(
						selectAllMembers
					);
				}}>
				<Flexbox flexDirection="row" alignItems="center">
					<div style={{ cursor: "pointer" }} onClick={() => {
					}}>
						<FontAwesomeIcon icon="trash" />
					</div>
				</Flexbox>
			</MultiSelectToolbar>;

		if (this.props.selectedMembers.length === 0) {
			multiSelectToolbar = null;
		}

		return multiSelectToolbar;
	}
}

export default branch({
	selectedMembers: ["appState", "selectedMembers"],
}, MultiSelectMembersToolbar);